import React, { useRef, useState } from 'react';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { TextField, Typography, InputAdornment, Checkbox, withStyles, Radio, Snackbar } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import { addDocter } from '../../store/actions/dokterAction';
import { DatePicker, KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import Autocomplete from '@material-ui/lab/Autocomplete';
import search from '../../assets/ic_date.png';
import bg_notif from '../../assets/bg_notif.png';
import circle from '../../assets/circle.png';
import ic_checkmark from '../../assets/ic_checkmark.png';
import ic_search from '../../assets/ic_search.png';
import ImageUploader from 'react-images-upload';
import Loader from 'react-loader-spinner'
import api from '../api';
import FindPatient from './findPatient';
import IcDelete from '../../assets/ic_delete.png';
import { ComponentToPrint } from './ComponentToPrint';
import { useHistory } from 'react-router';
import ic_error from '../../assets/ic_exclamation.png';
import ErrorRequest from '../ErrorRequest';
import CloseIcon from '@material-ui/icons/Close';
import { green } from '@material-ui/core/colors';
import { format } from 'date-fns';
import MuiAlert from '@material-ui/lab/Alert';
import UploadFile from "../components/UploadMultipleFile";
import { NumberFormatCustom } from '../../library/Util';
import InputMask from 'react-input-mask';
import { customOptions2 } from '../../library/CustomTable';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const pageStyle = `{size: 3.075in 10.25in}`;

const GreenRadio = withStyles({
    root: {
        color: green[400],
        '&$checked': {
            color: green[600],
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

export default function DaftarReservasi(props) {
    const componentRef = useRef()
    const dispatch = useDispatch();
    const history = useHistory()
    const [uploadVisible, setUploadVisible] = useState(false)
    const [status, setStatus] = React.useState(false)
    const [idPasien, setIdPasien] = React.useState(null)
    const [dataPoli, setDataPoli] = React.useState([])
    const [visibleListPoli, setVisibleSetListPoli] = React.useState(false)
    const [loading, setLoading] = React.useState(false);
    const [poli, setPoli] = React.useState([])
    const [selectedPoli, setSelectedPoli] = React.useState(null)
    const [newDocter, setnewDocter] = React.useState({
        kodeDokter: "",
        spesialisDokter: "",
        alamat: "",
        durasiperiksa: "",
        namaDokter: "",
        poliklinik: "",
        pengalamanDokter: ""
    })
    const [paymentMethod, setPaymentMethod] = React.useState(null)
    const [dateAndTime, setDateAndTime] = React.useState(null)
    const [listDokter, setListDokter] = React.useState([])
    const [namaPasien, setNamaPasien] = React.useState(null)
    const [noKtp, setNoKtp] = React.useState(null)
    const [bodPasien, setBodPasien] = React.useState(null)
    const [alamatPasien, setAlamatPasien] = React.useState(null)
    const [rekamMedis, setRekamMedis] = React.useState('')
    const [jenisKelamin, setJenisKelamin] = React.useState(null)
    const [selectedDokter, setSelectedDokter] = React.useState(null)
    const [noHp, setNoHp] = React.useState("")
    const [noTelp, setNoTelp] = React.useState("")
    const [keluhan, setKeluhan] = React.useState("")
    const [idDokter, setIdDokter] = React.useState(null)
    const [visibleFindPatient, setVisibleFindPatient] = React.useState(false)
    const [doctor_detail_schedule_id, set_doctor_detail_schedule_id] = React.useState(null)
    const [slotWaktu, setSlotWaktu] = React.useState([])
    const [categoryProvider, setCategoryProvider] = React.useState([])
    const [pickCategory, setPickCategory] = React.useState(null)
    const [photo, setPhoto] = React.useState("")
    const [pictures, setPicture] = useState([])
    const [succes, setSucces] = useState([])
    const [selectedPatient, setSelectedPatient] = useState([])
    const [listIdDokter, setListIdDokter] = useState([])
    const [flagEdit, setFlagEdit] = useState("")
    const [visible_time_schedule, set_visible_time_schedule] = useState(false)
    const [jadwalPeriksa, setJadwalPeriksa] = useState(null)
    const [errorText, setErrorText] = useState(null)
    const [errorJadwal, setErrorJadwal] = useState(false)
    const [visibleSlotWaktu, setVisibleSlotWaktu] = useState(false)
    const [timeValue, setTimeValue] = useState(null)
    const [visibleJadwal, setVisibleJadwal] = React.useState(false)
    const [visibleRemark, setVisibleRemark] = React.useState(false)
    const [remark, setRemark] = React.useState(false)
    const [noRujukan, setNoRujukan] = React.useState("")
    const [namaPasienBPJS, setNamaPasienBPJS] = React.useState("")
    const [noSEP, setNoSEP] = React.useState("")
    const [dateRujukan, setDateRujukan] = React.useState(null)
    const [namaPasienAsuransi, setNamaPasienAsuransi] = React.useState("")
    const [noKartuBPJS, setNoKartuBPJS] = React.useState("")
    const [noKartuAsuransi, setNoKartuAsuransi] = React.useState("")
    const [idAsuransi, setIdAsuransi] = React.useState("")
    const [visibleError, setVisibleError] = React.useState(false)
    const [visibleOpenPendukung, setVisibleOpenPendukung] = React.useState(false)
    const [errorMessage, setErrorMessage] = React.useState(null)
    const [pickAsuransi, setPickAsuransi] = React.useState(null)
    const [arrayAsuransi, setArrayAsuransi] = React.useState([])
    const [rsRujukan] = useState([])
    const [pickRSRujukan, setPickRSRujukan] = useState(null)
    const [namaRS, setNamaRS] = React.useState("")

    const [errorNama, setErrorNama] = React.useState(false)
    const [errorKTP, setErrorKTP] = React.useState(false)
    const [errorBod, setErrorBod] = React.useState(false)
    const [errorAlamat, setErrorAlamat] = React.useState(false)
    const [errorRM, setErrorRM] = React.useState(false)
    const [errorGender, setErrorGender] = React.useState(false)
    const [errorHP, setErrorHP] = React.useState(false)
    const [errorNoTelp, setErrorNoTelp] = React.useState(false)
    const [errorPembayaran, setErrorPembayaran] = React.useState(false)
    const [errorRujukan, setErrorRujukan] = React.useState(false)
    const [errorDateRujukan, setErrorDateRujukan] = React.useState(false)
    const [textErrorDateRujukan, setTextErrorDateRujukan] = React.useState("")
    const [errorProvider, setErrorProvider] = React.useState(false)
    const [textErrorRujukan, setTextErrorRujukan] = React.useState("")

    const [messageErrorNama, setMessageErrorNama] = React.useState(null)
    const [messageErrorKTP, setMessageErrorKTP] = React.useState(null)
    const [messageErrorBod, setMessageErrorBod] = React.useState(null)
    const [messageErrorAlamat, setMessageErrorAlamat] = React.useState(null)
    const [messageErrorRM, setMessageErrorRM] = React.useState(null)
    const [messageErrorGender, setMessageErrorGender] = React.useState(null)
    const [messageErrorHP, setMessageErrorHP] = React.useState(null)
    const [messageErrorNoTelp, setMessageErrorNoTelp] = React.useState(null)
    const [messageErrorPembayaran, setMessageErrorPembayaran] = React.useState(null)
    const [messageErrorProvider, setMessageErrorProvider] = React.useState(null)
    const [errorRequest, setErrorRequest] = React.useState(false)
    const [disableButton, setDisableButton] = React.useState(false)
    const [errorRequestMessage, setErrorRequestMessage] = React.useState(null)
    const [visibleSearch, setVisibleSearch] = React.useState(false)
    const [searchName, setSearchName] = React.useState(null)
    const [appointmentID, setAppointmentID] = React.useState("")
    const [bookingID, setBookingID] = React.useState("")
    const [listProvider, setListProvider] = React.useState([])
    const [provider, setProvider] = React.useState(null)
    const [visibleNotes, setVisibleNotes] = React.useState(false)
    const [visiblePublicNote, setVisiblePublicNote] = React.useState(false)
    const [visibleInternalNote, setVisibleInternalNote] = React.useState(false)
    const [messageAlert, setMessageAlert] = useState("")
    const [statusAlert, setStatusAlert] = useState("")
    const [openAlert, setOpenAlert] = useState(false);
    const [existingData, setExistingData] = useState(false);

    const [percentage, setpercentage] = useState('0')
    const [uploadstatus, setuploadstatus] = useState("")
    const [result, setresult] = useState("")
    const [secondUpload, setSecondUpload] = useState(true)
    const [fileSatu, setFileSatu] = useState(null)
    const [fileDua, setFileDua] = useState(null)
    const [nameFileSatu, setNameFileSatu] = useState(null)
    const [sizeFileSatu, setSizeFileSatu] = useState("")
    const [nameFileDua, setNameFileDua] = useState(null)
    const [sizeFileDua, setSizeFileDua] = useState("")

    const [formated, setFormated] = useState("")

    let startDate;
    let endDate;

    const listKunjungan = [
        { id: 1, name: "Rujukan FKTP" },
        { id: 2, name: "Rujukan Internal" },
        { id: 3, name: "Kontrol" },
        { id: 4, name: "Rujukan Antar RS" },
    ]
    const [kunjungan, setKunjungan] = React.useState(listKunjungan[0])

    const listPaymentOption = [
        {
            id: 1,
            name: "UMUM"
        },
        {
            id: 2,
            name: "Jaminan Non-BPJS Kesehatan"
        },
        {
            id: 3,
            name: "BPJS"
        },
    ]

    const handleOnChange = (e) => {
        const { name, value } = e.target
        setnewDocter({
            ...newDocter,
            [name]: value
        })
    }

    const dummyList = [
        { name: 'Laki-laki' },
        { name: 'Perempuan' },
    ]

    React.useEffect(() => {
        getDataPoli()
        getCategoryProvider()
        getParam()
    }, [])

    React.useEffect(() => {
        getJadwalPeriksa()
    }, [paymentMethod, selectedPoli, dateAndTime, selectedDokter])

    React.useEffect(() => {
        forceUpdate()
    }, [])

    const getParam = () => {
        api.create().getParameter().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let idx = response.data.data.findIndex((val) => val.param_code === "MEDICAL_RECORD_NO_FORMAT")
                    console.log(idx);
                    if (idx > -1) {
                        setFormated(response.data.data[idx].param_value)
                    }
                }
            }
        })
    }

    const handleFind = (data) => {
        console.log(data);
        setNoRujukan("")
        setNamaPasienBPJS("")
        setNoSEP("")
        setDateRujukan(null)
        setNamaPasienAsuransi("")
        setNoKartuBPJS("")
        setNoKartuAsuransi("")
        let gender = data.gender === 'P' ? "Perempuan" : "Laki-laki"
        setNamaPasien(data.name)
        setErrorNama(false)
        setMessageErrorNama(null)
        setNoKtp(data.identity_no)
        setBodPasien(data.date_of_birth)
        setAlamatPasien(data.address)
        setRekamMedis(data.medical_record_no)
        if (data != false) {
            let indexJenisKelamin = dummyList.findIndex((val) => val.name === gender)
            setJenisKelamin(dummyList[indexJenisKelamin])
        }
        setNoTelp(data.phone)
        setNoHp(data.mobilePhone ? data.mobilePhone : '')
        getListAsuransi(data.medical_record_no, paymentMethod && paymentMethod.id === 2 ? "" : "&without_insurance=1")
        forceUpdate()
    }

    const handleResetData = () => {
        setSelectedPatient([])
        setNamaPasien("")
        setNoKtp("")
        setBodPasien(new Date())
        setAlamatPasien("")
        setRekamMedis("")
        setJenisKelamin("")
        setNoHp("")
        setNoTelp("")
        setIdPasien(null)
        setFlagEdit("")
        forceUpdate()
    }

    const handleCloseError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    if (dateAndTime !== null) {
        let formatPlusWeek = new Date(dateAndTime).setDate(new Date(dateAndTime).getDate() + 5)
        let tanggal = new Date(dateAndTime).getDate()
        let bulan = new Date(dateAndTime).getMonth() + 1
        let tahun = new Date(dateAndTime).getFullYear()
        let tanggalPlusWeek = new Date(formatPlusWeek).getDate()
        let bulanPlusWeek = new Date(formatPlusWeek).getMonth() + 1
        let tahunPlusWeek = new Date(formatPlusWeek).getFullYear()
        startDate = `${tahun}-${bulan < 10 ? `0${bulan}` : bulan}-${tanggal < 10 ? `0${tanggal}` : tanggal}`
        endDate = `${tahunPlusWeek}-${bulanPlusWeek < 10 ? `0${bulanPlusWeek}` : bulanPlusWeek}-${tanggalPlusWeek}`
    }

    const getJadwalPeriksa = () => {
        if (dateAndTime && selectedDokter && paymentMethod && selectedPoli) {
            let params;
            let id = selectedDokter.id;
            let payment = paymentMethod.id == 3 ? [1, 3] : [2, 3]
            params = `filter={"doctor_id":[${id}],"service_type":[${payment}]}&date_filter={"schedule_date": {"start": "${startDate}", "end":"${endDate}"}}`
            api.create().filterDokter(params).then(response => {
                console.log(response, selectedPoli);
                if (response.data) {
                    if (response.data.status === true) {
                        if (response.data.data.length > 0) {
                            let temp = []
                            response.data.data[0].polyclinic.map(item => {
                                if (selectedPoli.id === item.polyclinic_id) {
                                    item.schedule.map(el => {
                                        // console.log(el);
                                        if (startDate === el.date) {
                                            if (el.deleted_at === null) {
                                                temp.push(el)
                                            }
                                        }
                                    })
                                }
                            })
                            setVisibleJadwal(temp.length > 0 ? true : false)
                            setListIdDokter(temp)
                            set_visible_time_schedule(true)
                        } else {
                            setListIdDokter([])
                            setVisibleJadwal(false)
                        }
                    }
                }
            })
        }
    }

    const getTimeSchedule = (data) => {
        let params;
        if (paymentMethod && selectedPoli && dateAndTime && selectedDokter) {
            params = `polyclinic_id=${selectedPoli.id}&date=${format(new Date(dateAndTime), 'yyyy-MM-dd')}&id=${selectedDokter.id}&payment_type=${paymentMethod.id}`
            api.create().getTimeSlot(params).then(response => {
                if (response.data.data) {
                    let temp = []
                    if (response.data.data.length > 0) {
                        response.data.data[0].schedule.map((el, idx) => {
                            console.log(el);
                            if (data.time_start === el.time_start) {
                                el.detail_schedule.map((item, index) => {
                                    temp.push({
                                        time: `${item.detail_time_start.slice(0, 5)} - ${item.detail_time_end.slice(0, 5)} (${item.is_available === 0 ? `Tidak Tersedia` : "Tersedia"})`,
                                        id: item.id,
                                        is_available: item.is_available === 0 ? `Tidak Tersedia` : "Tersedia",
                                        remark: el.remarks,
                                        is_leave: el.is_leave,
                                        is_holiday: el.is_holiday,
                                        notes: el.doctor_notes,
                                        index: index,
                                        internal_notes: el.internal_notes
                                    })
                                })
                            }
                        })
                        console.log(temp);
                        setSlotWaktu(temp)
                    }
                }
            })
        }
    }


    const getDataPoli = () => {
        api.create().getListMasterPoliActive("activeinactive=1").then(response => {
            console.log(response);
            if (response.data) {
                setDataPoli(response.data.data)
            }
        })
    }

    const getDataDokter = (poli, date) => {
        let params;
        if (paymentMethod) {
            params = `payment_type=${paymentMethod ? paymentMethod.id : null}&${poli ? `polyclinic_id=${poli.id}` : `polyclinic_id=${selectedPoli ? selectedPoli.id : ''}`}&${date ? `date_schedule=${format(new Date(date), 'yyyy-MM-dd')} - ${format(new Date(date), 'yyyy-MM-dd')}` : ''}`
            // if (startDate) {
            //     params = `payment_type=[${paymentMethod ? paymentMethod.id : null}]&${poli ? `polyclinic_id=${poli.id}` : `polyclinic_id=${selectedPoli ? selectedPoli.id : ''}`}&date_schedule=${new Date(dateAndTime).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })} - ${new Date(dateAndTime).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })}`
            // }
        }
        api.create().getListDokterFilter(params).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true && response.data.data != null) {
                    let data = []
                    response.data.data.map((item, index) => {
                        if (item.deleted_at === null) {
                            data.push(item)
                        }
                    })
                    setListDokter(data)
                    forceUpdate()
                }
            }
            setLoading(false)
        })
    }

    const onDrop = (e) => {
        console.log(e);
    }

    const uploadFoto = () => {
        setUploadVisible(false)
    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleDaftar = () => {
        let regexNumber = /^[0-9]*$/
        console.log(noKtp.length);
        if (!namaPasien) {
            setErrorNama(true)
            setMessageErrorNama("Nama Pasien harus diisi")
        } else if (!bodPasien) {
            setErrorBod(true)
            setMessageErrorBod("Tanggal Lahir Pasien harus diisi")
        } else if (!noKtp) {
            setErrorKTP(true)
            setMessageErrorKTP("No KTP harus diisi")
        } else if (!regexNumber.test(noKtp)) {
            setErrorKTP(true)
            setMessageErrorKTP("No KTP harus berisi angka")
        } else if (noKtp.length < 16) {
            setErrorKTP(true)
            setMessageErrorKTP("No KTP harus 16 digit")
        } else if (jenisKelamin === null || jenisKelamin === "") {
            setErrorGender(true)
            setMessageErrorGender("Jenis Kelamin Pasien harus diisi")
        } else if (noHp === null || noHp === "") {
            setErrorHP(true)
            setMessageErrorHP("No. HP Pasien harus diisi")
        } else if (!regexNumber.test(noHp)) {
            setErrorHP(true)
            setMessageErrorHP("No. Handphone Harus Berisi Angka")
        } else if (!regexNumber.test(noTelp)) {
            setErrorNoTelp(true)
            setMessageErrorNoTelp("No. Telepon Harus Berisi Angka")
        } else if (!paymentMethod) {
            setErrorPembayaran(true)
            setMessageErrorPembayaran("Metode Pembayaran Pasien harus diisi")
        } else if (!alamatPasien) {
            setErrorAlamat(true)
            setMessageErrorAlamat("Alamat Pasien harus diisi")
        } else {
            setLoading(true)
            let date = new Date(bodPasien).getDate() < 10 ? `0${new Date(bodPasien).getDate()}` : new Date(bodPasien).getDate()
            let month = new Date(bodPasien).getMonth() + 1 < 10 ? `0${new Date(bodPasien).getMonth() + 1}` : new Date(bodPasien).getMonth() + 1
            let year = new Date(bodPasien).getFullYear()
            let tanggalLahir = `${year}-${month}-${date}`
            let formData = new FormData()
            let files = []
            if (fileSatu) {
                files.push(fileSatu)
            }
            if (fileDua) {
                files.push(fileDua)
            }
            console.log(paymentMethod);
            formData.append('patient_name', namaPasien)
            formData.append('patient_phone', noTelp)
            formData.append('patient_mobile_phone', noHp)
            formData.append('patient_gender', jenisKelamin.name === "Laki-laki" ? 'L' : 'P')
            formData.append('patient_date_of_birth', tanggalLahir)
            if (files.length > 0) {
                files.map((item) => {
                    formData.append('files[]', item)
                })
            }
            if (noKtp != undefined) {
                formData.append('patient_identity_no', noKtp)
            } else {
                formData.append('patient_identity_no', "")
            }
            if (rekamMedis != undefined) {
                formData.append('patient_medical_record_no', rekamMedis)
            } else {
                formData.append('patient_medical_record_no', "")
            }
            if (!alamatPasien) {
                formData.append('patient_address', "")
            } else {
                formData.append('patient_address', alamatPasien)
            }
            if (doctor_detail_schedule_id !== null) {
                formData.append('doctor_schedule_detail_id', doctor_detail_schedule_id)
            }
            formData.append('payment_option', paymentMethod ? paymentMethod.id : null)
            formData.append('notes', keluhan)
            if (paymentMethod && paymentMethod.id === 3) {
                if (noRujukan !== "" && dateRujukan === null) {
                    setErrorDateRujukan(true)
                    setTextErrorDateRujukan("Tanggal Rujukan wajib diisi")
                    setLoading(false)
                } else {
                    formData.append('reference_no', noRujukan)
                    noKartuBPJS !== "" && formData.append('patient_bpjs_no', noKartuBPJS)
                    formData.append('patient_bpjs_name', namaPasienBPJS)
                    formData.append('sep_no', noSEP)
                    dateRujukan && formData.append('reference_date', format(new Date(dateRujukan), 'yyyy-MM-dd'))
                    formData.append('bpjs_type_of_visit', kunjungan ? kunjungan.id : null)
                    formData.append('is_admin', 1)
                    // console.log('INI BODY');
                    // console.log(JSON.stringify(formData));
                    console.log(...formData);
                    api.create().createReservation(formData).then(response => {
                        console.log(response);
                        if (response.data) {
                            setLoading(false)
                            if (response.data.status === true) {
                                if (response.data.data) {
                                    setSucces(response.data.data)
                                    setStatus(true)
                                    setAppointmentID(response.data.data.appointment_id)
                                    setBookingID(response.data.data.booking_id)
                                }
                            } else {
                                if (response.data.data === "Kuota dokter sudah penuh, anda akan menambahkan reservasi di luar kuota dokter. Apakah anda yakin?") {
                                    setVisibleError(true)
                                    setErrorMessage(response.data.data)
                                } else if (String(response.data.data).includes("Apakah anda yakin")) {
                                    setVisibleError(true)
                                    setErrorMessage(response.data.data)
                                } else if (response.data.data.doctor_schedule_detail_id === "doctor schedule detail id wajib diisi.") {
                                    setErrorRequest(true)
                                    setErrorRequestMessage("Silahkan pilih jadwal periksa")
                                } else if (String(response.data.data).includes("anda yakin")) {
                                    setVisibleError(true)
                                    setErrorMessage(response.data.data)
                                } else {
                                    setErrorRequest(true)
                                    setErrorRequestMessage(response.data.data)
                                }
                            }
                        }
                    })
                }
            } else if (paymentMethod && paymentMethod.id === 2) {
                if (noKartuAsuransi !== "" && provider === null) {
                    setErrorProvider(true)
                    setMessageErrorProvider("Provider harus diisi")
                    setLoading(false)
                } else {
                    if (provider) {
                        formData.append('patient_provider_code', provider.code)
                        formData.append('patient_insurance_name', provider.name)
                        formData.append('patient_provider_category', pickCategory.type)
                    }
                    formData.append('patient_insurance_no', noKartuAsuransi)
                    formData.append('patient_insurance_card_name', namaPasienAsuransi)
                    if (pickAsuransi !== null) {
                        formData.append('patient_insurance_id', pickAsuransi.insurance_no)
                    }
                    formData.append('is_admin', 1)
                    // console.log('INI BODY');
                    // console.log(JSON.stringify(formData));
                    console.log(...formData);
                    api.create().createReservation(formData).then(response => {
                        console.log(response);
                        if (response.data) {
                            setLoading(false)
                            if (response.data.status === true) {
                                if (response.data.data) {
                                    setSucces(response.data.data)
                                    setStatus(true)
                                    setAppointmentID(response.data.data.appointment_id)
                                    setBookingID(response.data.data.booking_id)
                                }
                            } else {
                                if (response.data.data === "Kuota dokter sudah penuh, anda akan menambahkan reservasi di luar kuota dokter. Apakah anda yakin?") {
                                    setVisibleError(true)
                                    setErrorMessage(response.data.data)
                                } else if (String(response.data.data).includes("Apakah anda yakin")) {
                                    setVisibleError(true)
                                    setErrorMessage(response.data.data)
                                } else if (response.data.data.doctor_schedule_detail_id === "doctor schedule detail id wajib diisi.") {
                                    setErrorRequest(true)
                                    setErrorRequestMessage("Jadwal Periksa tidak tersedia")
                                } else {
                                    setErrorRequest(true)
                                    setErrorRequestMessage(response.data.data)
                                }
                            }
                        }
                    })
                }
            } else {
                formData.append('is_admin', 1)
                // console.log('INI BODY');
                // console.log(JSON.stringify(formData));
                console.log(...formData);
                api.create().createReservation(formData).then(response => {
                    console.log(response);
                    if (response.data) {
                        setLoading(false)
                        if (response.data.status === true) {
                            if (response.data.data) {
                                setSucces(response.data.data)
                                setStatus(true)
                                setAppointmentID(response.data.data.appointment_id)
                                setBookingID(response.data.data.booking_id)
                            }
                        } else {
                            if (response.data.data === "Kuota dokter sudah penuh, anda akan menambahkan reservasi di luar kuota dokter. Apakah anda yakin?") {
                                setVisibleError(true)
                                setErrorMessage(response.data.data)
                            } else if (String(response.data.data).includes("Apakah anda yakin")) {
                                setVisibleError(true)
                                setErrorMessage(response.data.data)
                            } else if (response.data.data.doctor_schedule_detail_id === "doctor schedule detail id wajib diisi.") {
                                setErrorRequest(true)
                                setErrorRequestMessage("Jadwal Periksa tidak tersedia")
                            } else {
                                setErrorRequest(true)
                                setErrorRequestMessage(response.data.data)
                            }
                        }
                    }
                })
            }
        }
    }

    const handleForceReservation = () => {
        setVisibleError(false)
        setLoading(true)
        let date = new Date(bodPasien).getDate() < 10 ? `0${new Date(bodPasien).getDate()}` : new Date(bodPasien).getDate()
        let is_force = true
        let month = new Date(bodPasien).getMonth() + 1 < 10 ? `0${new Date(bodPasien).getMonth() + 1}` : new Date(bodPasien).getMonth() + 1
        let year = new Date(bodPasien).getFullYear()
        let tanggalLahir = `${year}-${month}-${date}`
        let formData = new FormData()
        if (idPasien === null) {
            formData.append('patient_name', namaPasien)
            formData.append('patient_phone', noTelp)
            formData.append('patient_mobile_phone', noHp)
            formData.append('patient_gender', jenisKelamin.name === "Laki-laki" ? 'L' : 'P')
            formData.append('patient_date_of_birth', tanggalLahir)
            if (noKtp != undefined) {
                formData.append('patient_identity_no', noKtp)
            } else {
                formData.append('patient_identity_no', "")
            }
            if (rekamMedis != undefined) {
                formData.append('patient_medical_record_no', rekamMedis)
            } else {
                formData.append('patient_medical_record_no', "")
            }
            if (!alamatPasien) {
                formData.append('patient_address', "")
            } else {
                formData.append('patient_address', alamatPasien)
            }
            formData.append('doctor_schedule_detail_id', doctor_detail_schedule_id)
            formData.append('payment_option', paymentMethod ? paymentMethod.id : null)
            formData.append('notes', keluhan)
            if (pictures != false) {
                formData.append('files[]', pictures[0])
            }
            if (paymentMethod && String(paymentMethod.id) === "3") {
                if (noRujukan !== "" && dateRujukan === null) {
                    setErrorDateRujukan(true)
                    setTextErrorDateRujukan("Tanggal Rujukan wajib diisi")
                    setLoading(false)
                } else {
                    // formData.append('patient_provider_code', noRujukan)
                    formData.append('reference_no', noRujukan)
                    noKartuBPJS !== "" && formData.append('patient_bpjs_no', noKartuBPJS)
                    formData.append('patient_bpjs_name', namaPasienBPJS)
                    formData.append('sep_no', noSEP)
                    dateRujukan && formData.append('reference_date', format(new Date(dateRujukan), 'yyyy-MM-dd'))
                    formData.append('bpjs_type_of_visit', kunjungan ? kunjungan.id : null)
                }
            } else if (paymentMethod && String(paymentMethod.id) === "2") {
                if (provider) {
                    formData.append('patient_provider_code', provider.code)
                    formData.append('patient_insurance_name', provider.name)
                    formData.append('patient_provider_category', pickCategory.type)
                }
                formData.append('patient_insurance_card_name', namaPasienAsuransi)
                formData.append('patient_insurance_no', noKartuAsuransi)
                if (pickAsuransi !== null) {
                    formData.append('patient_insurance_id', pickAsuransi.insurance_no)
                }
            }
        } else {
            formData.append("patient_id", selectedPatient.id)
            formData.append('doctor_schedule_detail_id', doctor_detail_schedule_id)
            formData.append('payment_option', paymentMethod ? paymentMethod.id : null)
            formData.append('notes', keluhan)
        }
        formData.append('is_admin', 1)
        formData.append('force_reservation', 1)
        console.log(...formData);
        api.create().createReservation(formData).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data) {
                        setLoading(false)
                        setSucces(response.data.data)
                        setAppointmentID(response.data.data.appointment_id)
                        setBookingID(response.data.data.booking_id)
                        setStatus(true)
                    }
                } else {
                    setLoading(false)
                    setErrorRequest(true)
                    setErrorRequestMessage(response.data.data)
                }
            }
        })
    }

    const handleClose = () => {
        setVisibleSetListPoli(false)
    }

    const handleCheked = (index) => {
        setLoading(true)
        setDateAndTime(new Date())
        setSelectedDokter(null)
        set_visible_time_schedule(false)
        setVisibleJadwal(false)
        setSelectedPoli(dataPoli[index])
        // setPoli(poli.concat(dataPoli[index]))
        getDataPoli()
        handleClose()
        getDataDokter(dataPoli[index], new Date())
        forceUpdate()
    }

    const onClose = () => {
        setVisibleFindPatient(false)
    }

    const handleToDetail = () => {
        api.create().getReservasiDokter().then(response => {
            console.log(response)
            let temp = []
            if (response.data) {
                if (response.data.status === true) {
                    setLoading(false)
                    response.data.data.map((item, index) => {
                        let monthData = new Date(item.doctor_schedule_date).getMonth() + 1
                        let monthNow = new Date().getMonth() + 1
                        let dateData = new Date(item.doctor_schedule_date).getDate()
                        let dateNow = new Date().getDate()
                        if (monthData >= monthNow) {
                            if (dateData >= dateNow) {
                                let arr = [
                                    index + 1,
                                    item.booking_id,
                                    item.doctor_name,
                                    item.polyclinics_name,
                                    item.patient_name,
                                    item.patient_phone,
                                    item.queue_number,
                                    item.doctor_schedule_date,
                                    item.doctor_schedule_time,
                                    item.patient_schedule_check,
                                    item.reservation_from,
                                    item.appointment_status_name,
                                    item.is_emergency,
                                    item.appointment_id,
                                    item.doctor_id,
                                    item.doctor_schedule_detail_id,
                                    item.doctor_schedule_id,
                                ]
                                temp.push(arr)
                            } else if (dateData < dateNow && monthData > monthNow) {
                                let arr = [
                                    index + 1,
                                    item.booking_id,
                                    item.doctor_name,
                                    item.polyclinics_name,
                                    item.patient_name,
                                    item.patient_phone,
                                    item.queue_number,
                                    item.doctor_schedule_date,
                                    item.doctor_schedule_time,
                                    item.patient_schedule_check,
                                    item.reservation_from,
                                    item.appointment_status_name,
                                    item.is_emergency,
                                    item.appointment_id,
                                    item.doctor_id,
                                    item.doctor_schedule_detail_id,
                                    item.doctor_schedule_id,
                                ]
                                temp.push(arr)

                            }
                        }
                    })
                }
            }
            api.create().getDetailReservasiDokter(appointmentID).then(response => {
                if (response.data) {
                    if (response.data.status === true) {
                        setLoading(false)
                        const emergency = {
                            "doctor_schedule_id": temp[temp.length - 1],
                            "doctor_schedule_detail_id": temp[temp.length - 2],
                        }
                        if (response.data.data) {
                            const data = response.data.data
                            history.push({
                                pathname: '/dokter/detail-reservasi-dokter',
                                name: 'Detail Reservasi',
                                state: {
                                    data,
                                    emergency,
                                    jadwalPeriksa: data.patient_schedule,
                                    idDokter: data.doctor.id,
                                    is_emergency: data.is_emergency,
                                    id: data.appointment_id,
                                    intent: 'daftar'
                                }
                            })
                        }
                    }
                }
            })
        })
    }

    const doFilter = (name) => {
        console.log(name);
        const payload = `?activeinactive=1&keyword=${name}`
        api.create().getListPoli(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data != false) {
                        if (response.data.data.length > 0) {
                            let data = []
                            response.data.data.map((item) => {
                                if (item.deleted_at === null) {
                                    data.push(item)
                                }
                            })
                            setDataPoli(data)
                        }
                    } else {
                        setDataPoli([])
                    }
                }
            }
        })
    }

    const getListAsuransi = (rm, without) => {
        api.create().getListAsuransi(rm, without).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data !== null) {
                        let data = response.data.data
                        let array = []
                        if (data.patient_insurances) {
                            if (data.patient_insurances.length > 0) {
                                data.patient_insurances.map((item, index) => {
                                    array.push(item)
                                })
                                setArrayAsuransi(array)
                                setExistingData(true)
                                console.log(array);
                                forceUpdate()
                            } else {
                                setExistingData(false)
                                setArrayAsuransi([])
                            }
                        } else {
                            setExistingData(false)
                            setArrayAsuransi([])
                        }
                        setNoKartuBPJS(data.bpjs_no)
                        setNamaPasienBPJS(data.bpjs_name === null ? data.name : data.bpjs_name)
                        setNoSEP(data.sep_no === null ? '' : data.sep_no)
                    } else {
                        setExistingData(false)
                        // setOpenAlert(true)
                        // setMessageAlert(response.data.message)
                        // setStatusAlert("warning")
                    }
                }
            }
        })
    }

    const getListProvider = () => {
        api.create().getListProvider().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setListProvider(response.data.data)
                }
            }
        })
    }

    const getCategoryProvider = () => {
        api.create().getCategoryProvider().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setCategoryProvider(response.data.data)
                    forceUpdate()
                }
            }
        })
    }

    const getProviderByCode = (code) => {
        let payload = {
            "business_partner_code": code,
        }
        api.create().getProviderByCode(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.message === "Data not found!") {
                        setPickCategory(null)
                        setProvider(null)
                        forceUpdate()
                    } else {
                        let idCat = categoryProvider.findIndex((val) => val.type === response.data.data.type)
                        console.log(idCat);
                        if (idCat > -1) {
                            setPickCategory(categoryProvider[idCat])
                            getProviderByCategory(response.data.data.type, response.data.data.code)
                            forceUpdate()
                        }
                    }
                }
            }
        })
    }

    const getProviderByCategory = (type, code) => {
        api.create().getProviderByCategory(type).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setListProvider(response.data.data)
                    let idProv = response.data.data.findIndex((val) => val.code === code)
                    if (idProv > -1) {
                        setProvider(response.data.data[idProv])
                        forceUpdate()
                    }
                    forceUpdate()
                }
            }
            setLoading(false)
        })
    }

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 2000, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    const handleButton = (item) => {
        if (item.is_holiday === 1) {
            setDisableButton(true)
        } else {
            setDisableButton(false)
        }
    }

    const disableSundays = (date) => {
        // console.log(date);
        // if (format(new Date(date), 'yyyy-MM-dd') === '2021-07-29') {
        //     return true
        // } else {
        return false
        // }
    }

    const fileHandler = (event) => {
        console.log(event)
        setNameFileSatu(event.name)
        setSizeFileSatu((event.size / 1000).toFixed(0))
        setFileSatu(event)

        // let length = event.name.split(".").length
        // let fileType = event.name.split(".")[length - 1]
    }

    const fileHandlerSecond = (event) => {
        console.log(event)
        setNameFileDua(event.name)
        setSizeFileDua((event.size / 1000).toFixed(0))
        setFileDua(event)

        // let length = event.name.split(".").length
        // let fileType = event.name.split(".")[length - 1]
    }

    return (
        <div style={{ height: props.height - 100, overflow: 'scroll' }}>
            <Snackbar open={openAlert} autoHideDuration={2000} onClose={handleCloseError}>
                <Alert onClose={handleCloseError} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div style={{ marginTop: 20 }}>
                {
                    loading && (loadingComponent)
                }
                <Typography>Data Reservasi</Typography>
                <div className="grid grid-2x" style={{ padding: 20, paddingRight: 50, paddingLeft: 50, marginTop: -10 }}>
                    <div className="column-1">
                        <div className="">
                            <Autocomplete
                                style={{ width: '85%' }}
                                options={listPaymentOption}
                                getOptionLabel={(option) => option.name}
                                name='Opsi Pembayaran'
                                id="payment"
                                placeholder="pilih opsi pembayaran"
                                defaultValue="pilih opsi pembayaran"
                                onChange={(event, newInputValue) => {
                                    setPaymentMethod(newInputValue)
                                    setErrorPembayaran(false)
                                    setSlotWaktu([])
                                    setMessageErrorPembayaran(null)
                                    setSelectedPoli(null)
                                    setDateAndTime(null)
                                    setVisibleRemark(false)
                                    setTimeValue(null)
                                    set_visible_time_schedule(false)
                                    setJadwalPeriksa(null)
                                    setSelectedDokter(null)
                                    forceUpdate()
                                }}
                                value={paymentMethod}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                        InputLabelProps={{ style: { color: '#7e8085' } }}
                                        label="Opsi Pembayaran"
                                        error={errorPembayaran}
                                        helperText={messageErrorPembayaran}
                                    />
                                }
                            />
                        </div>
                        <div className="">
                            <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                <KeyboardDatePicker
                                    margin="normal"
                                    label="Tanggal"
                                    format="dd/MM/yyyy"
                                    minDate={new Date()}
                                    placeholder="Pilih tanggal"
                                    disabled={selectedPoli ? false : true}
                                    value={dateAndTime}
                                    onChange={(date) => {
                                        setDateAndTime(date)
                                        var b = new Date(date)
                                        if (!isNaN(b.getTime())) {
                                            setLoading(true)
                                            setSlotWaktu([])
                                            setTimeValue(null)
                                            setVisibleRemark(false)
                                            getDataDokter(null, date)
                                        }
                                    }}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    style={{ width: '85%', cursor: 'pointer', marginTop: 5 }}
                                    inputProps={{
                                        style: {
                                            fontSize: 14,
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 16,
                                            color: selectedPoli ? '#7e8085' : '#d0d2d9',
                                        }
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                        <div className="">
                            {
                                visible_time_schedule !== false ?
                                    <div className="card" style={{ border: 'none' }}>
                                        <Typography style={{ fontSize: '11px', color: '#a5a5a5', marginTop: listIdDokter == false ? 10 : 2 }}>Pilih Jadwal Periksa</Typography>
                                        <div style={{ textAlign: 'center', width: '100%' }}>
                                            {listIdDokter == false ?
                                                <div>
                                                    <Typography>Jadwal Tidak Tersedia</Typography>
                                                </div>
                                                :
                                                <div style={{ width: '100%' }}>
                                                    <div style={{ display: 'flex', flexFlow: 'wrap' }}>
                                                        {listIdDokter.map((el, idx) => {
                                                            return (
                                                                <div style={{ margin: 20, cursor: 'pointer', width: 152, maxHeight: 30, minHeight: 30, borderRadius: 16, backgroundColor: timeValue === idx ? "#2A9C6C" : 'white', border: timeValue === idx ? '1px solid white' : '1px solid #34b68b', color: timeValue === idx ? "white" : 'black' }}
                                                                    onClick={() => {
                                                                        setTimeValue(idx)
                                                                        setIdDokter(el.id)
                                                                        getTimeSchedule(el)
                                                                        setVisibleRemark(true)
                                                                        set_doctor_detail_schedule_id(null)
                                                                        setJadwalPeriksa(null)
                                                                        // set_visible_time_schedule(false)
                                                                        console.log(el);
                                                                        handleButton(el)
                                                                        forceUpdate()
                                                                    }}
                                                                >
                                                                    <Typography>{`${el.time_start.slice(0, 5)} - ${el.time_end.slice(0, 5)}`}</Typography>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>

                                                    {timeValue !== null ?
                                                        <div style={{ width: '85%', display: 'flex' }}>
                                                            <TextField
                                                                style={{ width: '92%' }}
                                                                disabled={true}
                                                                multiline
                                                                label={listIdDokter[timeValue].remarks === "" || listIdDokter[timeValue].notes === ""  ? null : listIdDokter[timeValue].remarks !== null || listIdDokter[timeValue].notes !== null  ? "Catatan Publik" : null}
                                                                maxRows={1}
                                                                rows={1}
                                                                InputProps={{
                                                                    disableUnderline: true,
                                                                    style: {
                                                                        color: 'black'
                                                                    }
                                                                }}
                                                                InputLabelProps={{
                                                                    style: {
                                                                        fontSize: 15, textAlign: 'left'
                                                                    }
                                                                }}
                                                                inputProps={{
                                                                    style: {
                                                                        color: 'red', fontSize: 12, textAlign: 'left'
                                                                    }
                                                                }}
                                                                value={listIdDokter[timeValue].is_leave === 1 || listIdDokter[timeValue].is_holiday === 1 ? listIdDokter[timeValue].notes : listIdDokter[timeValue].remarks === null ? '' : listIdDokter[timeValue].remarks}
                                                            />
                                                            {listIdDokter[timeValue].notes && listIdDokter[timeValue].notes.length > 50 || listIdDokter[timeValue].remarks && listIdDokter[timeValue].remarks.length > 50 && (
                                                                <div style={{ width: '15%', display: 'flex', justifyContent: 'flex-end', cursor: 'pointer', marginTop: 22 }}
                                                                    onClick={() => {
                                                                        console.log(listIdDokter[timeValue].remarks.length);
                                                                        setVisiblePublicNote(true)
                                                                    }}
                                                                >
                                                                    <Typography style={{ color: '#37a7ed', fontSize: 12 }}>Lihat Detail</Typography>
                                                                </div>
                                                            )}
                                                        </div> : null
                                                        // <div style={{ marginTop: 20 }}>
                                                        //     <Typography style={{ textAlign: 'left', fontSize: '12px', color: 'red' }}>{listIdDokter[timeValue].is_leave === 1 || listIdDokter[timeValue].is_holiday === 1 ? listIdDokter[timeValue].notes : listIdDokter[timeValue].remarks === null ? '-' : listIdDokter[timeValue].remarks}</Typography>
                                                        // </div> : null
                                                    }

                                                    {slotWaktu && slotWaktu.length > 0 && (slotWaktu[0].internal_notes !== null || slotWaktu[0].internal_notes !== '') &&  (
                                                        <div style={{ width: '85%', display: 'flex' }}>
                                                            <TextField
                                                                style={{ width: '92%', marginTop: 10 }}
                                                                disabled={true}
                                                                multiline
                                                                label={slotWaktu[0].internal_notes === "" ? null : slotWaktu[0].internal_notes !== null ? "Catatan Internal" : null}
                                                                maxRows={1}
                                                                rows={1}
                                                                InputProps={{
                                                                    disableUnderline: true,
                                                                    style: {
                                                                        color: 'black'
                                                                    }
                                                                }}
                                                                InputLabelProps={{
                                                                    style: {
                                                                        fontSize: 15, textAlign: 'left'
                                                                    }
                                                                }}
                                                                inputProps={{
                                                                    style: {
                                                                        color: '#a4a4a4', fontSize: 12, textAlign: 'left'
                                                                    }
                                                                }}
                                                                value={slotWaktu[0].internal_notes}
                                                            />
                                                            {slotWaktu && slotWaktu[0].internal_notes && slotWaktu[0].internal_notes.length > 20 && (
                                                                <div style={{ width: '15%', display: 'flex', justifyContent: 'flex-end', cursor: 'pointer', marginTop: 22 }}
                                                                    onClick={() => {
                                                                        setVisibleInternalNote(true)
                                                                    }}
                                                                >
                                                                    <Typography style={{ color: '#37a7ed', fontSize: 12 }}>Lihat Detail</Typography>
                                                                </div>
                                                            )}
                                                        </div>

                                                    )}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    : null
                            }
                        </div>

                    </div>
                    <div className="column-2" style={{ marginTop: -4 }}>
                        <div className="">
                            <TextField
                                style={{ width: '85%', cursor: 'pointer' }}
                                disabled={paymentMethod ? false : true}
                                onClick={() => paymentMethod ? setVisibleSetListPoli(true) : null}
                                label="Klinik"
                                defaultValue="Pilih Klinik"
                                value={selectedPoli !== null ? `Klinik ${selectedPoli.name.toUpperCase()}` : ""}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 16,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                        <div className="">
                            <Autocomplete
                                style={{ width: '85%', marginTop: 10 }}
                                options={listDokter}
                                disabled={selectedPoli ? false : true}
                                getOptionLabel={(option) => option.name}
                                disableClearable
                                onChange={(event, newInputValue) => {
                                    setSelectedDokter(newInputValue)
                                    // setDataPoli(newInputValue ? newInputValue.polyclinic : newInputValue)
                                    setTimeValue(null)
                                    setVisibleRemark(false)
                                    setSlotWaktu([])
                                    forceUpdate()
                                }}
                                value={selectedDokter}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                        InputLabelProps={{ style: { color: selectedPoli ? '#7e8085' : '#d0d2d9' } }}
                                        label="Pilih Dokter"
                                    />
                                }
                            />
                        </div>
                        {visibleJadwal && (
                            <div className="">
                                {timeValue !== null ?
                                    <Autocomplete
                                        options={slotWaktu}
                                        getOptionLabel={(option) => {
                                            return (
                                                option.time
                                            )
                                        }}
                                        getOptionDisabled={(option) =>
                                            option.index !== slotWaktu.length - 1 && option.is_available === "Tidak Tersedia"
                                        }
                                        style={{ width: '85%', marginTop: 10 }}
                                        debug
                                        name='jadwalPeriksa'
                                        id="jadwalPeriksa"
                                        placeholder="Pilih Jadwal Periksa"
                                        error="Jadwal Sudah Penuh"
                                        onChange={(event, newInputValue) => {
                                            set_doctor_detail_schedule_id(newInputValue ? newInputValue.id : newInputValue)
                                            setJadwalPeriksa(newInputValue)
                                            forceUpdate()
                                        }}
                                        value={jadwalPeriksa}
                                        renderInput={(params) => {
                                            setErrorJadwal(params.inputProps.value != "" && params.inputProps.value.slice(15, 23) !== "Tersedia" ? true : false)
                                            setErrorText(params.inputProps.value != "" && params.inputProps.value.slice(15, 23) !== "Tersedia" ? "Jadwal Sudah Penuh" : null)
                                            return (
                                                <TextField
                                                    {...params}
                                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                                    label="Jadwal Periksa"
                                                    placeholder="pilih jadwal periksa"
                                                    error={errorJadwal}
                                                    helperText={errorText}
                                                />
                                            )
                                        }
                                        }
                                    />
                                    : null
                                }
                            </div>
                        )}
                        {slotWaktu && slotWaktu.length > 0 && (
                            <div style={{ width: '87%', display: 'flex' }}>
                                <TextField
                                    style={{ width: '92%', marginTop: 10 }}
                                    disabled={true}
                                    multiline
                                    maxRows={2}
                                    rows={2}
                                    InputProps={{
                                        disableUnderline: true,
                                        style: {
                                            color: 'black'
                                        }
                                    }}
                                    inputProps={{
                                        style: {
                                            letterSpacing: 1.5, color: '#a4a4a4', fontSize: 14
                                        }
                                    }}
                                    value={slotWaktu[0].notes}
                                />
                                {slotWaktu && slotWaktu[0].notes && slotWaktu[0].notes.length > 20 && (
                                    <div style={{ width: '15%', display: 'flex', justifyContent: 'flex-end', cursor: 'pointer', marginTop: 16 }}
                                        onClick={() => {
                                            setVisibleNotes(true)
                                        }}
                                    >
                                        <Typography style={{ color: '#37a7ed', fontSize: 12 }}>Lihat Detail</Typography>
                                    </div>
                                )}
                            </div>

                        )}
                    </div>
                </div>
            </div>
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: props.width - (props.open === true ? 350 : 120), fontSize: 16 }}>
                    <Typography>Kelengkapan Data Pasien</Typography>
                    <div style={{ marginRight: props.open === true ? 140 : 150 }}>
                        <Typography style={{ borderBottom: '1px solid #ff5b5b', color: '#ff5b5b', cursor: 'pointer', fontSize: 13, }}
                            onClick={() => handleResetData()}
                        >Reset Data</Typography>
                    </div>
                </div>
                <div className="grid grid-2x grid-mobile-none" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                    <div className="column-1">
                        <div className="">
                            <TextField
                                style={{ width: '85%', marginTop: -15 }}
                                id="namaPasien"
                                name="namaPasien"
                                label="Nama Pasien"
                                required={true}
                                value={namaPasien || ""}
                                error={errorNama}
                                helperText={messageErrorNama}
                                placeholder={"input nama pasien"}
                                onChange={(e) => {
                                    setNamaPasien(e.target.value)
                                    setErrorNama(false)
                                    setMessageErrorNama(null)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 16,
                                        color: '#7e8085',
                                    }
                                }}
                                InputProps={{
                                    endAdornment:
                                        <InputAdornment position="end" style={{ marginRight: '5%' }}>
                                            <div style={{ cursor: 'pointer' }}
                                                onClick={() => setVisibleFindPatient(true)}
                                                title="Cari Pasien"
                                            >
                                                <img src={ic_search} />
                                            </div>
                                        </InputAdornment>,
                                }}
                            />
                        </div>
                        <div className="">
                            <TextField
                                style={{ width: '85%', marginTop: 10 }}
                                id="noKtp"
                                name="noKtp"
                                label="No KTP"
                                value={noKtp || ""}
                                error={errorKTP}
                                required={true}
                                helperText={messageErrorKTP}
                                placeholder={"input nomor induk pasien"}
                                onChange={(e) => {
                                    setNoKtp(e.target.value)
                                    setErrorKTP(false)
                                    setMessageErrorKTP(null)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    },
                                    maxlength: 16
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 16,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                        <div className="">
                            <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    id="bod"
                                    label="Tanggal Lahir"
                                    required={true}
                                    format="dd/MM/yyyy"
                                    minDate={new Date('01-01-1901')}
                                    placeholder="Pilih tanggal lahir pasien"
                                    value={bodPasien}
                                    helperText={messageErrorBod}
                                    error={errorBod}
                                    onChange={(date) => {
                                        setBodPasien(date)
                                        setErrorBod(false)
                                        setMessageErrorBod(null)
                                    }}
                                    // onClick={(date) => {
                                    //     setBodPasien(date)
                                    //     setErrorBod(false)
                                    //     setMessageErrorBod(null)
                                    //     forceUpdate()
                                    // }}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    style={{ width: '85%', cursor: 'pointer', marginTop: 15 }}
                                    inputProps={{
                                        style: {
                                            fontSize: 14,
                                        },
                                        maxlength: 16
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 16,
                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                        <div className="">
                            <TextField
                                style={{ width: '85%', marginTop: 5 }}
                                label="No. Telepon"
                                required={true}
                                error={errorNoTelp}
                                helperText={messageErrorNoTelp}
                                value={noTelp}
                                placeholder={"Input no Telepon pasien"}
                                onChange={(e) => {
                                    setNoTelp(e.target.value)
                                    setErrorNoTelp(false)
                                    setMessageErrorNoTelp(null)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 16,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                        <div className="">
                            <TextField
                                style={{ width: '85%', marginTop: 15 }}
                                id="alamat"
                                name="alamat"
                                label="Alamat"
                                error={errorAlamat}
                                helperText={messageErrorAlamat}
                                required={true}
                                value={alamatPasien || ""}
                                placeholder={"input alamat pasien"}
                                onChange={(e) => {
                                    setAlamatPasien(e.target.value)
                                    setErrorAlamat(false)
                                    setMessageErrorAlamat(null)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 16,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className="column-2">
                        <div className="">
                            <InputMask
                                mask={String(formated).split('#').join('*')}
                                value={rekamMedis}
                                onChange={(e) => {
                                    setRekamMedis(e.target.value)
                                }}
                            >
                                {() =>
                                    <TextField
                                        style={{ width: '85%', marginTop: -15 }}
                                        label="No Rekam Medis"
                                        error={errorRM}
                                        helperText={messageErrorRM}
                                        value={rekamMedis}
                                        placeholder={"input No rekam medis"}
                                        // onChange={(e) => {
                                        //     console.log(e);
                                        //     // setRekamMedis(e.target.value)
                                        //     // setrekamMedis(e.target.mask)
                                        //     // setErrorRM(false)
                                        //     // setMessageErrorRM(null)
                                        //     forceUpdate()
                                        // }}
                                        inputProps={{
                                            style: {
                                                fontSize: 14,
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 16,
                                                color: '#7e8085',
                                            }
                                        }}
                                    />
                                }
                            </InputMask>
                        </div>
                        <div className="">
                            <Autocomplete
                                style={{ width: '85%', marginTop: 15 }}
                                options={dummyList}
                                getOptionLabel={(option) => option.name}
                                debug
                                name='jenisKelamin'
                                id="jenisKelamin"
                                value={jenisKelamin || ""}
                                onChange={(a, b) => {
                                    setJenisKelamin(b)
                                    setErrorGender(false)
                                    setMessageErrorGender(null)
                                    forceUpdate()
                                }}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                        InputLabelProps={{ style: { color: '#7e8085' } }}
                                        label="Jenis Kelamin"
                                        error={errorGender}
                                        helperText={messageErrorGender}
                                    />
                                }
                            />
                        </div>
                        <div className="">
                            <TextField
                                style={{ width: '85%', marginTop: 14 }}
                                id="noHp"
                                name="noHp"
                                label="No. Handphone"
                                required={true}
                                error={errorHP}
                                helperText={messageErrorHP}
                                value={noHp || ""}
                                placeholder={"Input no handphone pasien"}
                                onChange={(e) => {
                                    setNoHp(e.target.value)
                                    setErrorHP(false)
                                    setMessageErrorHP(null)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputProps={{
                                    maxLength: 12,
                                    startAdornment: <InputAdornment position="start" style={{ margin: 0, marginRight: 5, fontSize: 14, }}>+62</InputAdornment>,
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 16,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                        <div className="">
                            <TextField
                                style={{ width: '85%', marginTop: 10 }}
                                id="inputKeluhan"
                                name="inputKeluhan"
                                label="Catatan Pasien"
                                value={keluhan}
                                placeholder={"input No Catatan Pasien"}
                                onChange={(e) => {
                                    setKeluhan(e.target.value)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 16,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography>File Pendukung</Typography>
                </div>
                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                    <div className="column-1">
                        <div className="">
                            <TextField
                                style={{ width: '85%', marginTop: -5, cursor: 'pointer' }}
                                onClick={() => setUploadVisible(true)}
                                label="Upload File Medical Check Up / LAB"
                                value={`${nameFileSatu ? nameFileSatu : '-'}, ${nameFileDua ? nameFileDua : '-'}`}
                                inputProps={{
                                    style: {
                                        fontSize: 14, cursor: 'pointer'
                                    },
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 16,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                        {paymentMethod && paymentMethod.id === 3 ?
                            <div>
                                {/* <Autocomplete
                                    style={{ width: '85%', marginTop: 10 }}
                                    options={rsRujukan}
                                    getOptionLabel={(option) => option.type}
                                    debug
                                    value={pickRSRujukan}
                                    onChange={(a, newInputValue) => {
                                        setPickRSRujukan(newInputValue)
                                        forceUpdate()
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                            InputLabelProps={{ style: { color: '#7e8085' } }}
                                            label="Rujuk Rs Lain"
                                        />
                                    }
                                /> */}
                                <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        label="Tanggal Rujukan"
                                        required={noRujukan !== "" ? true : false}
                                        error={errorDateRujukan}
                                        helperText={textErrorDateRujukan}
                                        format="dd/MM/yyyy"
                                        minDate={new Date('01-01-1901')}
                                        placeholder="Tanggal Rujukan"
                                        value={dateRujukan}
                                        onChange={(date) => {
                                            setDateRujukan(date)
                                            setErrorDateRujukan(false)
                                            setTextErrorDateRujukan("")
                                        }}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        style={{ width: '85%', cursor: 'pointer' }}
                                        inputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            maxlength: 16
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 16,
                                                color: '#7e8085',
                                            }
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                                <TextField
                                    style={{ width: '85%', marginTop: 10 }}
                                    label="Nama Pasien BPJS"
                                    placeholder={"Input Nama Pasien BPJS"}
                                    inputProps={{
                                        style: {
                                            fontSize: 14
                                        },
                                    }}
                                    onChange={(e) => {
                                        setNamaPasienBPJS(e.target.value)
                                        forceUpdate()
                                    }}
                                    value={namaPasienBPJS}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 16,
                                            color: '#7e8085',
                                        }
                                    }}
                                />
                                {/* <TextField
                                    style={{ width: '85%', marginTop: 10 }}
                                    label="Nomor SEP"
                                    placeholder={"Input Nomor SEP"}
                                    inputProps={{
                                        style: {
                                            fontSize: 14
                                        },
                                    }}
                                    onChange={(e) => {
                                        setNoSEP(e.target.value)
                                        forceUpdate()
                                    }}
                                    value={noSEP}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 16,
                                            color: '#7e8085',
                                        }
                                    }}
                                /> */}
                            </div> :
                            paymentMethod && paymentMethod.id === 2 ?
                                <div>
                                    <Autocomplete
                                        style={{ width: '85%', marginTop: 10 }}
                                        options={categoryProvider}
                                        getOptionLabel={(option) => option.type}
                                        debug
                                        value={pickCategory}
                                        onChange={(a, newInputValue) => {
                                            setPickCategory(newInputValue)
                                            setProvider(null)
                                            if (newInputValue) {
                                                setLoading(true)
                                                getProviderByCategory(newInputValue && newInputValue.type)
                                            }

                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                required={noKartuAsuransi !== "" ? true : false}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Kategori Provider"
                                            />
                                        }
                                    />
                                    <Autocomplete
                                        style={{ width: '85%', marginTop: 10 }}
                                        options={listProvider}
                                        disabled={pickCategory === null ? true : false}
                                        getOptionLabel={(option) => option.name}
                                        debug
                                        value={provider}
                                        onChange={(a, newInputValue) => {
                                            setProvider(newInputValue)
                                            setErrorProvider(false)
                                            setMessageErrorProvider("")
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                required={noKartuAsuransi !== "" ? true : false}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Provider"
                                                error={errorProvider}
                                                helperText={messageErrorProvider}
                                            />
                                        }
                                    />
                                </div>
                                : null
                        }
                    </div>
                    <div className="column-2">
                        {paymentMethod && paymentMethod.id === 3 ?
                            <div>
                                {/* <TextField
                                    style={{ width: '85%', marginTop: -5 }}
                                    label="Nama RS"
                                    placeholder={"Input Nama RS"}
                                    inputProps={{
                                        style: {
                                            fontSize: 14
                                        },
                                    }}
                                    onChange={(e) => {
                                        setNamaRS(e.target.value)
                                        forceUpdate()
                                    }}
                                    value={namaRS}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 16,
                                            color: '#7e8085',
                                        }
                                    }}
                                /> */}
                                <TextField
                                    style={{ width: '85%', marginTop: -5 }}
                                    // required
                                    label="No Rujukan"
                                    placeholder={"Input No Rujukan"}
                                    inputProps={{
                                        style: {
                                            fontSize: 14
                                        },
                                    }}
                                    value={noRujukan}
                                    // error={errorRujukan}
                                    // helperText={textErrorRujukan}
                                    onChange={(e) => {
                                        setNoRujukan(e.target.value)
                                        setErrorDateRujukan(false)
                                        setTextErrorDateRujukan("")
                                        // setTextErrorRujukan("")
                                        // setErrorRujukan(false)
                                        forceUpdate()
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 16,
                                            color: '#7e8085',
                                        }
                                    }}
                                />

                                <TextField
                                    style={{ width: '85%', marginTop: 15 }}
                                    label="No Kartu"
                                    placeholder={"Input No Kartu BPJS"}
                                    inputProps={{
                                        style: {
                                            fontSize: 14
                                        },
                                    }}
                                    onChange={(e) => {
                                        setNoKartuBPJS(e.target.value)
                                        forceUpdate()
                                    }}
                                    value={noKartuBPJS}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 16,
                                            color: '#7e8085',
                                        }
                                    }}
                                />

                                <Autocomplete
                                    style={{ width: '85%', marginTop: 15 }}
                                    options={listKunjungan}
                                    getOptionLabel={(option) => option.name}
                                    debug
                                    disableClearable={true}
                                    name='kunjungan'
                                    id="kunjungan"
                                    value={kunjungan || ""}
                                    onChange={(a, b) => {
                                        setKunjungan(b)
                                        // setErrorGender(false)
                                        // setMessageErrorGender(null)
                                        forceUpdate()
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                            InputLabelProps={{ style: { color: '#7e8085' } }}
                                            label="Jenis Kunjungan"
                                        // error={errorGender}
                                        // helperText={messageErrorGender}
                                        />
                                    }
                                />
                            </div> :
                            paymentMethod && paymentMethod.id === 2 ?
                                <div>
                                    <TextField
                                        style={{ width: '85%' }}
                                        label="No Kartu Peserta Jaminan"
                                        placeholder={"Input No Kartu Peserta Jaminan"}
                                        inputProps={{
                                            style: {
                                                fontSize: 14
                                            },
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 16,
                                                color: '#7e8085',
                                            }
                                        }}
                                        onChange={(e) => {
                                            setNoKartuAsuransi(e.target.value)
                                            forceUpdate()
                                        }}
                                        value={noKartuAsuransi}
                                        InputProps={{
                                            endAdornment:
                                                <div style={{ display: 'flex' }}>
                                                    <InputAdornment position="end" style={{ marginRight: '5%' }}>
                                                        {existingData && (
                                                            <div style={{ cursor: 'pointer' }}
                                                                onClick={() => {
                                                                    setVisibleOpenPendukung(true)
                                                                }}
                                                            >
                                                                <img src={ic_search} />
                                                            </div>
                                                        )}
                                                    </InputAdornment>
                                                    <InputAdornment position="end" style={{ marginRight: '5%' }}>
                                                        {existingData && pickAsuransi && (
                                                            <div style={{ cursor: 'pointer' }}
                                                                onClick={() => {
                                                                    setPickAsuransi(null)
                                                                    setNoKartuAsuransi("")
                                                                }}
                                                            >
                                                                <div style={{ width: 24, height: 24, backgroundColor: '#278863', borderRadius: 15, textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                    <img src={IcDelete} style={{ width: 12, height: 12 }} />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </InputAdornment>
                                                </div>
                                            ,
                                        }}
                                    />
                                    <TextField
                                        style={{ width: '85%', marginTop: 10 }}
                                        label="Nama Tertera Dikartu Jaminan"
                                        placeholder={"Input Nama Tertera Dikartu Jaminan"}
                                        inputProps={{
                                            style: {
                                                fontSize: 14
                                            },
                                        }}
                                        onChange={(e) => {
                                            setNamaPasienAsuransi(e.target.value)
                                            forceUpdate()
                                        }}
                                        value={namaPasienAsuransi}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 16,
                                                color: '#7e8085',
                                            }
                                        }}
                                    />
                                </div>
                                : null
                        }
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', margin: '30px 10px' }}>
                <div
                    onClick={() => history.goBack()}
                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                </div>
                <div
                    onClick={() => disableButton === true ? null : handleDaftar()}
                    style={{ height: 32, width: 150, backgroundColor: disableButton ? 'grey' : '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', alignItems: 'center', justifyItems: 'center' }} >
                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5, marginLeft: 15 }}>Daftar Reservasi</Typography>
                </div>
            </div>

            {
                visibleFindPatient ?
                    <FindPatient
                        onClose={() => setVisibleFindPatient(false)}
                        data={(data) => setSelectedPatient(data)}
                        flagEdit={(param) => setFlagEdit(param)}
                        idPasien={(id) => setIdPasien(id)}
                        handleFind={(data) => handleFind(data)}
                        props={props}
                    />
                    : null
            }
            {
                visibleError ?
                    <div className="App app-popup-show">
                        <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white', height: '30vh', display: 'grid' }}>
                            <div style={{ margin: 'auto' }}>
                                <div style={{ width: 90, height: 90, borderRadius: 70, backgroundColor: '#34b68b', border: '3px solid #b3fde4', placeContent: 'center' }}>
                                    {/* <img src={circle} style={{width: 100, height: 100}}/> */}
                                    <img src={ic_error} style={{ width: 60, height: 60, marginTop: 10 }} />
                                </div>
                                <Typography style={{ fontStyle: 'bold', letterSpacing: 1.5, fontSize: 18 }}>Warning</Typography>
                            </div>
                            <div style={{ padding: '0 20px' }}>
                                <Typography>{errorMessage}</Typography>
                            </div>
                            <div style={{ margin: 'auto', width: '55%', display: 'flex', justifyContent: 'space-evenly', }}>
                                <div onClick={() => setVisibleError(false)} style={{ height: 32, width: 150, backgroundColor: 'white', borderRadius: 20, cursor: 'pointer', border: '1px solid #2a9c6c', color: '#2a9c6c' }} >
                                    <Typography style={{ color: '#2a9c6c', fontSize: 15, marginTop: 5 }}>Kembali</Typography>
                                </div>
                                <div onClick={() => handleForceReservation()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
            }

            {uploadVisible && (
                <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                    <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                        <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18 }}>Upload File</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => {
                                        setUploadVisible(false)
                                        forceUpdate()
                                    }}
                                >
                                    <img src={CloseImage} />
                                </button>
                            </div>
                        </div>

                        <UploadFile
                            type={uploadstatus}
                            percentage={percentage}
                            sizeUpload={props.location.state.sizeUpload}
                            result={result}
                            acceptedFiles={["JPG", "JPEG", "PNG", "PDF", "DOC", "DOCX"]}
                            onHandle={(dt) => {
                                fileHandler(dt)
                                setuploadstatus('idle')
                                setpercentage('0')
                            }}
                            docSize={sizeFileSatu}
                            docName={nameFileSatu}
                            onDrop={onDrop}
                            onUpload={() => {
                                // checkPreview()
                                // this.uploadAttachment(this.state.formData)
                            }}

                            onDelete={() => {
                                setNameFileSatu("")
                                setSizeFileSatu("")
                            }}
                        />

                        {secondUpload && (
                            <UploadFile
                                type={uploadstatus}
                                percentage={percentage}
                                sizeUpload={props.location.state.sizeUpload}
                                result={result}
                                acceptedFiles={["JPG", "JPEG", "PNG", "PDF", "DOC", "DOCX"]}
                                onHandle={(dt) => {
                                    fileHandlerSecond(dt)
                                    setuploadstatus('idle')
                                    setpercentage('0')
                                }}
                                docSize={sizeFileDua}
                                docName={nameFileDua}
                                onUpload={() => {
                                    // checkPreview()
                                    // this.uploadAttachment(this.state.formData)
                                }}

                                onDelete={() => {
                                    setNameFileDua("")
                                    setSizeFileDua("")
                                }}
                            />
                        )}
                    </div>
                </div>
            )}

            {status ?
                <div className="App app-popup-show">
                    <div className="popup-content" style={{ backgroundColor: 'transparent', width: '100%', display: 'flex', justifyContent: 'center' }}>
                        <div style={{ backgroundImage: `url(${bg_notif})`, backgroundRepeat: 'no-repeat', justifyContent: 'center', alignItems: 'center', width: 440, padding: '20px 0px', position: 'relative' }}>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                <img src={circle} style={{ width: 104, height: 104 }} />
                            </div>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: -72 }}>
                                <img src={ic_checkmark} style={{ width: 41, height: 41 }} />
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', top: 130, position: 'absolute', width: '100%' }}>
                                <Typography style={{ fontSize: '2rem', color: '#278863', textAlign: 'center' }} >Reservasi Berhasil</Typography>
                            </div>
                            <div style={{ width: 440, marginTop: 123 }}>
                                <div style={{ padding: '20px 20px 0px 20px', height: 360 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: 45 }}>
                                        <div style={{ color: '#bdc3c7', fontSize: 16, width: '34%' }}>
                                            <Typography style={{ textAlign: 'start' }} >Kode Reservasi</Typography>
                                        </div>
                                        <div style={{ marginLeft: '2%', width: '64%' }}>
                                            <Typography style={{ textAlign: 'start' }} >{succes.booking_id}</Typography>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: 5, height: 45 }}>
                                        <div style={{ color: '#bdc3c7', fontSize: 16, width: '34%' }}>
                                            <Typography style={{ textAlign: 'start', }} >No. Antrian</Typography>
                                        </div>
                                        <div style={{ marginLeft: '2%', width: '64%' }}>
                                            <Typography style={{ textAlign: 'start', }} >{succes.queue_number ? succes.queue_number : <Typography style={{ textAlign: 'start', fontSize: 12, color: 'red' }} >Nomor antrian akan didapatkan pada saat check in / kedatangan</Typography>}</Typography>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: 5, height: 45 }}>
                                        <div style={{ color: '#bdc3c7', fontSize: 16, width: '34%' }}>
                                            <Typography style={{ textAlign: 'start', }} >Poliklinik</Typography>
                                        </div>
                                        <div style={{ marginLeft: '2%', width: '64%' }}>
                                            <Typography style={{ textAlign: 'start', }} >{succes.polyclinic_name}</Typography>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: 5, height: 45 }}>
                                        <div style={{ color: '#bdc3c7', fontSize: 16, width: '34%' }}>
                                            <Typography style={{ textAlign: 'start', }} >Dokter</Typography>
                                        </div>
                                        <div style={{ marginLeft: '2%', width: '64%' }}>
                                            <Typography style={{ textAlign: 'start', }} >{succes.doctor_name}</Typography>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: 5, height: 45 }}>
                                        <div style={{ color: '#bdc3c7', fontSize: 16, width: '34%' }}>
                                            <Typography style={{ textAlign: 'start', }} >Nama Pasien</Typography>
                                        </div>
                                        <div style={{ marginLeft: '2%', width: '64%' }}>
                                            <Typography style={{ textAlign: 'start', }} >{succes.patient_name}</Typography>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: 5, height: 45 }}>
                                        <div style={{ color: '#bdc3c7', fontSize: 16, width: '34%' }}>
                                            <Typography style={{ textAlign: 'start', }} >Hari & Waktu</Typography>
                                        </div>
                                        <div style={{ marginLeft: '2%', width: '64%' }}>
                                            <Typography style={{ textAlign: 'start', }} >{succes.date_time}</Typography>
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <ReactToPrint
                                            pageStyle={pageStyle}
                                            onAfterPrint={() => {
                                                handleToDetail()
                                            }}
                                            trigger={() => {
                                                return (
                                                    <div
                                                        style={{ height: 30, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', margin: 'auto', }}
                                                    // style={{ cursor: 'pointer', height: '4vh', width: '25vh', backgroundColor: '#34b68b', borderRadius: '10vh', borderColor: '#34b68b', borderWidth: '.4vh', borderStyle: 'solid', alignItems: 'center', justifyContent: 'center', display: 'flex' }}
                                                    >
                                                        <Typography style={{ fontSize: 18, color: '#ffffff', textAlign: 'center' }}>Print</Typography>
                                                    </div>
                                                )
                                            }}
                                            content={() => componentRef.current}
                                        >
                                            <Typography style={{ fontSize: 18, color: '#ffffff', textAlign: 'center' }}>Print Reservasi</Typography>
                                        </ReactToPrint>
                                        <div style={{ display: 'none' }}>
                                            <ComponentToPrint
                                                namaDokter={succes.doctor_name}
                                                namaPoli={succes.polyclinic_name}
                                                desc={selectedDokter && selectedDokter.desc}
                                                noRekam={succes.patient_medical_record_no}
                                                namaPasien={succes.patient_name}
                                                dateTime={succes.date_time}
                                                pembayaran={succes.payment_option}
                                                dokterRoom={succes.doctor_room}
                                                noAntrian={succes.queue_number}
                                                qrCodeURL={succes.qrcode_url}
                                                bookingID={succes.booking_id}
                                                gender={succes.patient_gender}
                                                // lokasi={this.state.lokasi}
                                                // tipeAntrian={this.state.tipeAntrian}
                                                // regisAntrian={this.state.regisAntrian}
                                                ref={componentRef}
                                            />
                                        </div>
                                        <div
                                            onClick={() => {
                                                handleToDetail()
                                                setLoading(true)
                                            }}
                                            style={{ height: 30, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', margin: 'auto', }}
                                        >
                                            <Typography style={{ color: 'white', fontSize: 18, textAlign: 'center' }}>Tutup</Typography>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                : null
            }
            {visibleOpenPendukung && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 30, margin: 'auto', overflow: 'auto', width: 1000 }}>
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 30, borderTopLeftRadius: 30, backgroundColor: '#f5f5f5' }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18, }}>Pilih Jaminan</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => setVisibleOpenPendukung(false)}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div style={{ padding: '20px 20px 40px' }}>
                            {/* <Typography style={{ fontWeight: 'bold' }}>PILIH ASURANSI</Typography> */}
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ width: '10%' }} />
                                <div style={{ width: '20%' }}>
                                    <Typography style={{ textAlign: 'left', fontWeight: '500', color: '#2a9c6c' }}>No Kartu</Typography>
                                </div>
                                <div style={{ width: '35%' }}>
                                    <Typography style={{ textAlign: 'left', fontWeight: '500', color: '#2a9c6c' }}>Nama Provider</Typography>
                                </div>
                                <div style={{ width: '35%' }}>
                                    <Typography style={{ textAlign: 'left', fontWeight: '500', color: '#2a9c6c' }}>Nama Tertera Dikartu Jaminan</Typography>
                                </div>
                            </div>
                            {arrayAsuransi.length > 0 && arrayAsuransi.map((item, index) => {
                                return (
                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: 10 }}>
                                        <GreenRadio
                                            checked={false}
                                            onClick={() => {
                                                setPickAsuransi(item)
                                                setNamaPasienAsuransi(item.patient_name)
                                                setNoKartuAsuransi(item.insurance_no)
                                                setIdAsuransi(item.id)
                                                setVisibleOpenPendukung(false)
                                                getProviderByCode(item.provider_code)
                                                forceUpdate()
                                            }}
                                            // value="c"
                                            name="radio"
                                            style={{ padding: 0, width: '10%' }}
                                            inputProps={{ 'aria-label': 'C' }}
                                        />
                                        <div style={{ width: '20%', alignSelf: 'center' }}>
                                            <Typography style={{ textAlign: 'left' }} >{item.insurance_no}</Typography>
                                        </div>
                                        <div style={{ width: '35%', alignSelf: 'center' }}>
                                            <Typography style={{ textAlign: 'left' }}>{item.insurance_name}</Typography>
                                        </div>
                                        <div style={{ width: '35%', alignSelf: 'center' }}>
                                            <Typography style={{ textAlign: 'left' }}>{item.patient_name}</Typography>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            )}
            {
                errorRequest ?
                    <ErrorRequest
                        message={errorRequestMessage}
                        close={() => setErrorRequest(false)}
                    />
                    : null
            }
            {
                visibleListPoli ?
                    <div className="App app-popup-show">
                        <div className="popup-content background-white" style={{ height: '100%', position: 'absolute', right: 0, width: '33%', overflow: 'auto' }}>
                            <div className="popup-panel grid grid-2x" style={{ height: 64, backgroundColor: '#278863' }}>
                                <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                    <div className="popup-title">
                                        <span style={{ color: 'white', fontSize: 18, }}>List Klinik</span>
                                    </div>
                                </div>
                                <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                    <button
                                        type="button"
                                        className="btn btn-circle btn-white"
                                        onClick={() => handleClose()}
                                    >
                                        <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                    </button>
                                </div>
                            </div>
                            <div>
                                {
                                    !visibleSearch ?
                                        <img title="cari klinik" onClick={() => setVisibleSearch(true)} src={ic_search} style={{ marginTop: 10, display: 'flex', paddingLeft: 12, cursor: 'pointer' }} />
                                        :
                                        <div style={{ marginTop: 2, marginBottom: 10, display: 'flex', marginLeft: 11, width: '100%' }}>
                                            <TextField
                                                style={{ width: '90%' }}
                                                label="Pencarian Klinik"
                                                placeholder="input nama klinik"
                                                value={searchName}
                                                onChange={(e) => doFilter(e.target.value)}
                                                InputProps={{
                                                    endAdornment:
                                                        <InputAdornment position="end" style={{ marginRight: '5%' }}>
                                                            <CloseIcon
                                                                titleAccess="batal"
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => {
                                                                    getDataPoli()
                                                                    setVisibleSearch(false)
                                                                }}
                                                            />
                                                        </InputAdornment>
                                                }}
                                            />
                                        </div>
                                }
                                {
                                    dataPoli && dataPoli.map((el, idx) => {
                                        return (
                                            <div
                                                onClick={() => handleCheked(idx)}
                                                style={{ display: 'block', cursor: 'pointer' }}>
                                                <div
                                                    style={{ display: 'flex', marginTop: 20, borderBottom: '1px solid #ebebeb' }}>
                                                    <img src={el.media_path} style={{ width: 30, height: 30, marginLeft: '0.5em' }} />
                                                    <Typography style={{ marginLeft: '1em' }}>{el.name}</Typography>
                                                    {/* <CustomCheckbox
                                                        checked={el.checked}
                                                        onChange={() => handleCheked(idx)}
                                                        style={{position: 'absolute', right: 0}}
                                                    /> */}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    : null
            }

            {visibleNotes && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                        <div style={{ padding: 20 }}>
                            <textarea
                                value={slotWaktu[0].notes}
                                disabled
                                style={{ width: '100%', marginTop: 10, minHeight: 400 }}
                            />
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div
                                    onClick={() => setVisibleNotes(false)}
                                    style={{ height: 28, width: 100, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                                    <Typography style={{ color: 'white', fontSize: 13 }}>Tutup</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {visiblePublicNote && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                        <div style={{ padding: 20 }}>
                            <textarea
                                value={listIdDokter[timeValue].is_leave === 1 || listIdDokter[timeValue].is_holiday === 1 ? listIdDokter[timeValue].notes : listIdDokter[timeValue].remarks === null ? '-' : listIdDokter[timeValue].remarks}
                                disabled
                                style={{ width: '100%', marginTop: 10, minHeight: 400 }}
                            />
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div
                                    onClick={() => setVisiblePublicNote(false)}
                                    style={{ height: 28, width: 100, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                                    <Typography style={{ color: 'white', fontSize: 13 }}>Tutup</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {visibleInternalNote && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                        <div style={{ padding: 20 }}>
                            <textarea
                                value={slotWaktu[0].internal_notes}
                                disabled
                                style={{ width: '100%', marginTop: 10, minHeight: 400 }}
                            />
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div
                                    onClick={() => setVisibleInternalNote(false)}
                                    style={{ height: 28, width: 100, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                                    <Typography style={{ color: 'white', fontSize: 13 }}>Tutup</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}